var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.2708,
    height: 46.9401,
    transform: "matrix(-0.954141 -0.299357 0.277998 -0.960582 44.1489 58.9414)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_313_974",
    transform: "matrix(0.0111111 0 0 0.0109527 0 0.00712866)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_313_974",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAELElEQVR4nO2cS4geRRDHxwjRgCI+DgrRaNTd6ok55OIDLxpEfMSvahYG4vpVfUmE3Ix4EF/IHjcgiV5y8XFRLwYCPjBp9KR49yIBBSWgMahRMaDGELPS2YsP2I3pnqnqnf5Bn7/5/6iprnl8U1WFQqFQKBQKhb6Ym1t188z29fVIRkD8tCN+BZAPAfFngHIESH4C5FOO+Kgj3l237ereji1n1k0mF9fNeDMgP+9IvCP5xZEsnPvi3doZzLLxwdnL64ZbIHn9/4v95wLkY9p5bDE3twpI7nUoBxZP/fOX+6+KPqodzUz1AspTDvnLdHL/tlDmqyFTt+0ljvg5IP65E8FD3wxvuu+xixzJ44DyXZqK5d+B5MNQuaGvbyC5cW3brqmGDDST2wHlcAK5fwLJ+0FsODO0c5lhbduuAeIXHMrpyHZwEpBfCnO0diZzuNH4NofyeWQVnwmj3jROrtfOYxKgyU5A+SNyavjWIT+gncUmbXuhI9kX24sB+c317c7LtOOYpG7b1YD8VmQVnw6ztXYW66Obj93wHDFqZzFdyQ7lvdiZ2JHcr53FMhcA8huxs3GYi7WDmAYWb2FGbXyO+EntHKZxxBjm3MjN70A4K7SzmKXewtcB8o9xI5wcKSPccrMy8ieRLeOMG/E9S/7O0HHNZFdsXwaU17RzmGYDbrvWEZ+I3PxOQPPINdpZTAMo+6OrmeQZ7RymqUluTTBlHJ8e7bhUO4tpgOTj6JkZ5VntHKapm/HmBJJ/A+IrtbOYBpAPJejNr2rnMA0041uie/NZ0XyHdhbTuCQ38uXrcqm9/C3Q49H9mXhvf6WRIdCMt8ZLLm1jedHE7ySo5m/C+3V9FEbO72T8mqCi92lnyeF+80J022jGW7WzmMahvJxCtJuZXaedxTSA/EWC/lzeUV6Kup1cnaRtoOzvrTJypG64TSJ6JE9oZzGNQ9mTQvT0SO7WzmIah/JBCtHhiYx2FtMA8rEEG+HJcqGyBFNbHr4q0UZ4uL/SyJCpmcmdKUSH9/G0s5hmGnk2iWiSF7WzmAbCf//KaJfHjX4XRjscb+vhcPMFUN5OVNGNdhbTAPFHaSp6cpd2FtMA8adJNsMRb9LOYhpH8lUK0VMPjW/QzmIal+RhrCzU7aNXVIN4ek28N5U018cKx4qyJ6uvEoSLBXVxNIBXE7KqZPrP+qHKhXCwBoQtnNdC/r4a2o17p7DCZyeqnP4yDMgHs5OMfDAce5Xf5CHvastz5758+NZdlSMZyfbZSs5Its9ecgay/YqRbFi2X3GSDcr2K1ayIdl+xUs2INsPRrKibD84yQqy/WAl9yjbD15yD7J9kdx9Zfsiufs24ovk7nu2L5K73yB9kdy9bF8kdy/bF8ndy/ZFcveyfZHcxTeiUeYXPwl/ds1n9yC1UCgUCoVCobLAX1Dre5KtMzgwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewArrow);
export default __webpack_public_path__ + "static/media/reviewArrow.090a50a1a65000d3fb6f6c144c0b068e.svg";
export { ForwardRef as ReactComponent };